(() => {
  if (window.MaytrixInsideLoader) { window.MaytrixInsideLoader.scan(); return; }
  const bound = new WeakSet();
  let enginePromise;
  const loadEngine = url => {
    if (!enginePromise) enginePromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url; script.async = true;
      script.onload = resolve;
      script.onerror = () => { script.remove(); enginePromise = null; reject(new Error('Animation unavailable')); };
      document.head.appendChild(script);
    });
    return enginePromise;
  };
  const near = new IntersectionObserver(entries => {
    for (const { target, isIntersecting } of entries) {
      if (!isIntersecting || target.hidden) continue;
      for (const source of target.querySelectorAll('[data-srcset]')) source.srcset = source.dataset.srcset;
      for (const img of target.querySelectorAll('img[data-src]')) img.src = img.dataset.src;
      loadEngine(target.dataset.engineUrl).then(() => near.unobserve(target)).catch(() => {});
    }
  }, { rootMargin: '400px' });
  const scan = () => {
    for (const element of document.querySelectorAll('maytrix-inside-scroll')) {
      if (bound.has(element)) continue;
      bound.add(element); near.observe(element);
      if (element.dataset.placement !== 'review') continue;
      let reviewObserver;
      const sync = () => {
        const review = document.getElementById('myx-design-review');
        const active = review && !review.hidden && document.body.classList.contains('myx-review-open');
        element.hidden = !active;
        if (review && !reviewObserver) {
          reviewObserver = new MutationObserver(sync);
          reviewObserver.observe(review, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
          discovery.disconnect();
        }
      };
      const discovery = new MutationObserver(sync);
      discovery.observe(document.body, { childList: true, subtree: true });
      const bodyState = new MutationObserver(sync);
      bodyState.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      sync();
    }
  };
  window.MaytrixInsideLoader = { scan };
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
